export const VISIBLE_MONTHS_COUNT = 6;
export const MONTH_PROCESSING_FORMAT = 'YYYY-MM';
export const MONTH_DISPLAY_FORMAT = 'MMM';
export const DATE_FORMAT = 'DD-MMM-YY';
